import { writable } from 'svelte/store'
import type { Readable } from 'svelte/store'

export default <T>(promise: undefined | Promise<T>): Readable<boolean> => {
	if (promise === undefined) {
		const { subscribe } = writable(false)
		return { subscribe }
	}
	const { subscribe, set } = writable(true)

	// eslint-disable-next-line @typescript-eslint/no-floating-promises
	promise.finally(() => set(false))

	return {
		subscribe,
	}
}
